import React from 'react';
import PricingTable from '@/components/pricing/PricingTable/PricingTable';
import Hosting from '@/components/pricing/Hosting/Hosting';
import FeaturesTable from '@/components/pricing/FeaturesTable/FeaturesTable';

const Pricing: React.FC = () => {
  return (
    <div>
      <section className="py-20 min-h-[40vh] flex items-center">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 gradient-text">
            Cennik
          </h1>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            Przejrzyste ceny dopasowane do Twoich potrzeb
          </p>
        </div>
      </section>
      <PricingTable />
      <Hosting />
      <FeaturesTable />
    </div>
  );
};

export default Pricing;
